import { render } from "./myTasks.vue?vue&type=template&id=73b2452c&ts=true"
import script from "./myTasks.vue?vue&type=script&lang=ts"
export * from "./myTasks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__